import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import Icon from '../../../../components/icon/icon';
import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer } from '../heroSection/heroSection.styled';
import { SIGN_UP_PROCESS_CONFIG } from './signUpProcess.config';
import {
  ProcessesContainer,
  ProcessDot,
  ProcessItem,
  SignUpProcessContainer,
  SignUpProcessContent,
  SignUpProcessTitleContainer,
  ProcessContainer,
} from './signUpProcess.styled';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

const SignUpProcessTitle = () => {
  return (
    <SignUpProcessTitleContainer>
      <h2>
        Join other dog trainers and behaviourists who are treating themselves to simplified appointments and easy client
        management with <strong>Pata booking software</strong>
      </h2>
      <p>
        New to training or fully booked? Pata helps dog trainers schedule sessions, reduce no-shows, and stay organised
        in one simple, subscription-free booking platform.
      </p>
    </SignUpProcessTitleContainer>
  );
};

export function SignUpProcess() {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };
  // const theme = useTheme();
  return (
    <SignUpProcessContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-app-laptop-iphone.webp`}
        alt="Pata Partners app on laptop and iPhone"
        height={2000}
        width={2000}
      />
      <WidthContainer noBackground>
        <SectionContainer title={SignUpProcessTitle}>
          <ActionContainer>
            <Button onClick={handleSignUpClick}>Sign up today</Button>
            <Button buttonType="secondary" onClick={handleBookDemo}>
              Book a demo
            </Button>
          </ActionContainer>
        </SectionContainer>
      </WidthContainer>
    </SignUpProcessContainer>
  );
}
